<template>
  <SkuPicker ref="skuRef" :product-id="id" @back="onBack" />
</template>

<script setup>
import SkuPicker from 'src/components/SkuPicker.vue';
import { defineProps, computed, onMounted, ref } from 'vue';
import { useRoute } from 'src/utils/v2_helper/router';
import { useRouter } from '../../utils/v2_helper/router';
import { useIns } from '../../utils/v2_helper/common';
import { ADD_SUCCESS_RECOMMEND } from '../../utils/config';

const app = useIns();
const route = useRoute();
const router = useRouter();

const skuRef = ref();

const id = computed(() => route.params.id);

function onBack() {
  const { redirect } = route.query;
  if (redirect === route.name) return router.back();
  if (redirect) return router.push({ name: redirect });
  router.replace({ name: 'products-list' });
  app.$bus.$emit(ADD_SUCCESS_RECOMMEND);
}

onMounted(() => {
  skuRef.value.visible = true;
});
</script>
